var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { PropertyService } from './property.service';
import { PropertySearch } from './../models/index';
import { Router } from '@angular/router';
var ApartmentTypeService = /** @class */ (function (_super) {
    __extends(ApartmentTypeService, _super);
    function ApartmentTypeService(propertyService, apiCallService, router) {
        var _this = _super.call(this) || this;
        _this.propertyService = propertyService;
        _this.apiCallService = apiCallService;
        _this.router = router;
        return _this;
    }
    ApartmentTypeService.prototype.getApartmentTypes = function (propertySearch, sort, page) {
        var path = '/apartment_types';
        if (propertySearch) {
            path += this.apiCallService.getSeachUrlParams(propertySearch, sort, page);
        }
        return this.apiCallService.get(path);
    };
    ApartmentTypeService.prototype.getApartmentType = function (friendly_id) {
        return this.apiCallService.get('/apartment_types/' + friendly_id);
    };
    ApartmentTypeService.prototype.decodeUrlParams = function (params, advancedLimits, oldPropertySearch) {
        return this.propertyService.decodeUrlParams(params, advancedLimits, oldPropertySearch);
    };
    ApartmentTypeService.prototype.resolve = function (route) {
        var _this = this;
        var promise;
        var page = route.data['page'] ? route.data['page'] : 1;
        if (route.params['friendly_id'] === undefined) {
            if (route.data['property_search']) {
                promise = this.getApartmentTypes(route.data['property_search'], undefined, page);
            }
            else if (route.data['property_type']) {
                var propertySearch = this.propertyService.decodeUrlParams(route.queryParams);
                propertySearch.property_type = route.data['property_type'];
                promise = this.getApartmentTypes(propertySearch, undefined, page);
            }
            else {
                promise = this.getApartmentTypes(new PropertySearch(), undefined, 1);
            }
        }
        else {
            promise = this.getApartmentType(route.params['friendly_id'])
                .catch(function (error) {
                _this.router.navigate(['/apartamente']);
                throw error;
            });
        }
        return promise;
    };
    return ApartmentTypeService;
}(BaseApiService));
export { ApartmentTypeService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/apartment-type.service.ts.pre-build-optimizer.js